export const TRANSLATIONS_QUOTES = {
  create: {
    breadcrumbBack: 'quotes.create.breadcrumb_back',
    newQuote: 'quotes.create.new_quote',
    editQuote: 'quotes.create.edit_quote',
    notFound: 'quotes.create.not_found',
    defaultName: 'quotes.create.default_name',
    complete: 'quotes.create.complete',
    group: {
      title: 'quotes.create.group.title',
      employees: 'quotes.create.group.employees',
      employeesPrefilled: 'quotes.create.group.employees_prefilled',
      employeesHint: 'quotes.create.group.employees_hint',
      employeesRequired: 'quotes.create.group.employees_required',
      employeesMin: 'quotes.create.group.employees_min',
      averageAge: 'quotes.create.group.average_age',
      averageAgeRequired: 'quotes.create.group.average_age_required',
      averageAgeRange: 'quotes.create.group.average_age_range',
      optionalDetails: 'quotes.create.group.optional_details',
      quoteName: 'quotes.create.group.quote_name',
      segment: 'quotes.create.group.segment',
      segmentPlaceholder: 'quotes.create.group.segment_placeholder',
      segmentAll: 'quotes.create.group.segment_all'
    },
    planSelection: {
      title: 'quotes.create.plan_selection.title',
      selected: 'quotes.create.plan_selection.selected',
      perEmployee: 'quotes.create.plan_selection.per_employee',
      quotedPlan: 'quotes.create.plan_selection.quoted_plan',
      perEmployeeMonth: 'quotes.create.plan_selection.per_employee_month',
      whatsIncluded: 'quotes.create.plan_selection.whats_included'
    },
    employerPaidProducts: {
      title: 'quotes.create.employer_paid_products.title',
      selected: 'quotes.create.employer_paid_products.selected',
      completeGroupHint: 'quotes.create.employer_paid_products.complete_group_hint',
      choosePlanHint: 'quotes.create.employer_paid_products.choose_plan_hint',
      emptyTitle: 'quotes.create.employer_paid_products.empty_title',
      emptyDescription: 'quotes.create.employer_paid_products.empty_description'
    },
    voluntaryBenefits: {
      title: 'quotes.create.voluntary_benefits.title',
      selected: 'quotes.create.voluntary_benefits.selected',
      completeGroupHint: 'quotes.create.voluntary_benefits.complete_group_hint',
      choosePlanHint: 'quotes.create.voluntary_benefits.choose_plan_hint',
      emptyTitle: 'quotes.create.voluntary_benefits.empty_title',
      emptyDescription: 'quotes.create.voluntary_benefits.empty_description'
    },
    emptyState: {
      title: 'quotes.create.empty_state.title',
      description: 'quotes.create.empty_state.description'
    },
    products: {
      title: 'quotes.create.products.title',
      selected: 'quotes.create.products.selected',
      insurance: 'quotes.create.products.insurance',
      wellness: 'quotes.create.products.wellness',
      voluntary: 'quotes.create.products.voluntary',
      voluntarySubtitle: 'quotes.create.products.voluntary_subtitle',
      noneError: 'quotes.create.products.none_error',
      completeGroupHint: 'quotes.create.products.complete_group_hint'
    },
    row: {
      coveragePlan: 'quotes.create.row.coverage_plan',
      tier: 'quotes.create.row.tier',
      coverage: 'quotes.create.row.coverage',
      tobacco: 'quotes.create.row.tobacco',
      rate: 'quotes.create.row.rate',
      perEmployee: 'quotes.create.row.per_employee',
      commissionIncluded: 'quotes.create.row.commission_included',
      ageBand: 'quotes.create.row.age_band',
      viewRates: 'quotes.create.row.view_rates',
      ageData: 'quotes.create.row.age_data',
      enterAverageAge: 'quotes.create.row.enter_average_age',
      uploadQuickCensus: 'quotes.create.row.upload_quick_census',
      uploadQuickCensusHint: 'quotes.create.row.upload_quick_census_hint',
      uploadQuickCensusHelper: 'quotes.create.row.upload_quick_census_helper',
      uploadQuickCensusBtn: 'quotes.create.row.upload_quick_census_btn',
      censusLoaded: 'quotes.create.row.census_loaded',
      censusLoadedMeta: 'quotes.create.row.census_loaded_meta',
      removeCensus: 'quotes.create.row.remove_census',
      monthlyTotal: 'quotes.create.row.monthly_total'
    },
    censusModal: {
      title: 'quotes.create.census_modal.title',
      description: 'quotes.create.census_modal.description',
      dropzone: 'quotes.create.census_modal.dropzone',
      formats: 'quotes.create.census_modal.formats',
      upload: 'quotes.create.census_modal.upload',
      cancel: 'quotes.create.census_modal.cancel',
      apply: 'quotes.create.census_modal.apply',
      removeFile: 'quotes.create.census_modal.remove_file',
      errorValidation: 'quotes.create.census_modal.error_validation',
      downloadTemplate: 'quotes.create.census_modal.download_template',
      howDoesItWork: 'quotes.create.census_modal.how_does_it_work',
      instruction1Title: 'quotes.create.census_modal.instruction1_title',
      instruction1Sub: 'quotes.create.census_modal.instruction1_sub',
      instruction2Title: 'quotes.create.census_modal.instruction2_title',
      instruction2Sub: 'quotes.create.census_modal.instruction2_sub',
      instruction3Title: 'quotes.create.census_modal.instruction3_title',
      instruction3Sub: 'quotes.create.census_modal.instruction3_sub',
      validatingTitle: 'quotes.create.census_modal.validating_title',
      processingTitle: 'quotes.create.census_modal.processing_title',
      successTitle: 'quotes.create.census_modal.success_title',
      errorFormatTitle: 'quotes.create.census_modal.error_format_title',
      errorFormatModalTitle: 'quotes.create.census_modal.title_error_format',
      errorFewTitle: 'quotes.create.census_modal.error_few_step_title',
      errorManyTitle: 'quotes.create.census_modal.error_many_step_title',
      errorManyBannerTitle: 'quotes.create.census_modal.error_many_banner_title',
      errorMismatchTitle: 'quotes.create.census_modal.error_mismatch_title',
      errorMismatchBannerTitle: 'quotes.create.census_modal.error_mismatch_banner_title',
      errorMismatchDesc: 'quotes.create.census_modal.error_mismatch_desc',
      errorServiceTitle: 'quotes.create.census_modal.error_service_title',
      errorFormatDesc: 'quotes.create.census_modal.error_format_desc',
      errorFormatMessage: 'quotes.create.census_modal.error_format_message',
      errorServiceDesc: 'quotes.create.census_modal.error_service_desc',
      errorServiceNote: 'quotes.create.census_modal.error_service_note',
      mismatchUpdateTitle: 'quotes.create.census_modal.mismatch_update_title',
      mismatchUpdateSub: 'quotes.create.census_modal.mismatch_update_sub',
      mismatchDifferentTitle: 'quotes.create.census_modal.mismatch_different_title',
      mismatchDifferentSub: 'quotes.create.census_modal.mismatch_different_sub',
      mismatchBody: 'quotes.create.census_modal.mismatch_body',
      mismatchPrompt: 'quotes.create.census_modal.mismatch_prompt',
      mismatchOverTitle: 'quotes.create.census_modal.title_error_mismatch',
      mismatchOverBannerTitle: 'quotes.create.census_modal.mismatch_over_banner_title',
      footerContinue: 'quotes.create.census_modal.footer_continue',
      errorManyMore: 'quotes.create.census_modal.error_many_more',
      downloadErrorReport: 'quotes.create.census_modal.download_error_report',
      successEmployees: 'quotes.create.census_modal.success_employees',
      successAvgAge: 'quotes.create.census_modal.success_avg_age',
      successSub: 'quotes.create.census_modal.success_sub',
      ageBand: 'quotes.create.census_modal.age_band',
      employees: 'quotes.create.census_modal.employees',
      rateEe: 'quotes.create.census_modal.rate_ee',
      bandTotal: 'quotes.create.census_modal.band_total',
      errorSummary: 'quotes.create.census_modal.error_summary',
      row: 'quotes.create.census_modal.row',
      uploadDifferentFile: 'quotes.create.census_modal.upload_different_file',
      uploadNewCensus: 'quotes.create.census_modal.upload_new_census',
      uploadCorrectedFile: 'quotes.create.census_modal.footer_upload_corrected',
      tryAgain: 'quotes.create.census_modal.try_again',
      validatingStatus: 'quotes.create.census_modal.validating_status',
      warning: 'quotes.create.census_modal.warning',
      ageBandBreakdown: 'quotes.create.census_modal.age_band_breakdown',
      error: 'quotes.create.census_modal.error',
      success: 'quotes.create.census_modal.success',
      processingSlow: 'quotes.create.census_modal.processing_slow',
      processingNormal: 'quotes.create.census_modal.processing_normal',
      processingSuccessDesc: 'quotes.create.census_modal.processing_success_desc'
    },
    rateTable: {
      title: 'quotes.create.rate_table.title',
      age: 'quotes.create.rate_table.age',
      individual: 'quotes.create.rate_table.individual',
      partner: 'quotes.create.rate_table.partner',
      family: 'quotes.create.rate_table.family',
      partnerFamily: 'quotes.create.rate_table.partner_family'
    },
    leaveModal: {
      title: 'quotes.create.leave_modal.title',
      description: 'quotes.create.leave_modal.description',
      keepEditing: 'quotes.create.leave_modal.keep_editing',
      leaveAnyway: 'quotes.create.leave_modal.leave_anyway'
    },
    tobacco: {
      nonTobacco: 'quotes.create.tobacco.non_tobacco',
      tobacco: 'quotes.create.tobacco.tobacco'
    },
    summary: {
      title: 'quotes.create.summary.title',
      employerCost: 'quotes.create.summary.employer_cost',
      employerCostMeta: 'quotes.create.summary.employer_cost_meta',
      costBreakdown: 'quotes.create.summary.cost_breakdown',
      brokerCommission: 'quotes.create.summary.broker_commission',
      employeeFunded: 'quotes.create.summary.employee_funded',
      employeeFundedCount: 'quotes.create.summary.employee_funded_count',
      noProducts: 'quotes.create.summary.no_products',
      commissionIncluded: 'quotes.create.summary.commission_included',
      save: 'quotes.create.summary.save',
      update: 'quotes.create.summary.update'
    },
    tooltips: {
      employeesRequired: 'quotes.create.tooltips.employees_required',
      selectProduct: 'quotes.create.tooltips.select_product',
      ageRequired: 'quotes.create.tooltips.age_required',
      quoteNameRequired: 'quotes.create.tooltips.quote_name_required',
      noProductsAvailable: 'quotes.create.tooltips.no_products_available',
      chooseBundle: 'quotes.create.tooltips.choose_bundle'
    },
    toast: {
      saveError: 'quotes.create.toast.save_error'
    },
    editSuccessModal: {
      title: 'quotes.create.edit_success_modal.title',
      description: 'quotes.create.edit_success_modal.description',
      downloading: 'quotes.create.edit_success_modal.downloading',
      downloadPdf: 'quotes.create.edit_success_modal.download_pdf',
      downloadPdfError: 'quotes.create.edit_success_modal.download_pdf_error',
      doItLater: 'quotes.create.edit_success_modal.do_it_later',
      close: 'quotes.create.edit_success_modal.close'
    },
    createSuccessModal: {
      title: 'quotes.create.create_success_modal.title',
      description: 'quotes.create.create_success_modal.description',
      downloading: 'quotes.create.create_success_modal.downloading',
      downloadPdf: 'quotes.create.create_success_modal.download_pdf',
      downloadPdfError: 'quotes.create.create_success_modal.download_pdf_error',
      doItLater: 'quotes.create.create_success_modal.do_it_later',
      close: 'quotes.create.create_success_modal.close'
    }
  }
};
